import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

import type { GoogleReCAPTCHA } from '#src/components/recaptcha/index.tsx';

export enum WalletTab {
  // Open from outside the wallet
  RECOVER_KEY = 'recoverKey',
  RESTORE_WALLET = 'restoreWallet',
  GENERATE_KEYS = 'generateKeys',
  CHANGE_PASSWORD = 'changePassword',
  GET_PASSWORD = 'getPassword',

  // Open inside the wallet
  HOME = 'home',
  SETTINGS = 'settings',
  PRIVATE_KEY_EXPORT = 'privateKeyExport',
  SOLANA_PRIVATE_KEY_EXPORT = 'solanaPrivateKeyExport',
  DEPOSIT = 'deposit',
  ADD_FUNDS = 'addFunds',
  ADD_FUNDS_TO_FIAT_WALLET = 'addFundsToFiatWallet',
  ADD_FUNDS_TO_FIAT_WALLET_SUCCEEDED = 'addFundsToFiatWalletSucceeded',
  ADD_FUNDS_TO_FIAT_WALLET_SUCCEEDED_WITH_PROMO = 'addFundsToFiatWalletSucceededWithPromo',
  ADD_FUNDS_TO_FIAT_WALLET_REVIEW = 'addFundsToFiatWalletReview',
  ADD_FUNDS_TO_CRYPTO_WALLET = 'addFundsToCryptoWallet',
  ADD_FUNDS_TO_CRYPTO_WALLET_FIAT = 'addFundsToCryptoWalletFiat',
  ADD_FUNDS_TO_CRYPTO_WALLET_CRYPTO = 'addFundsToCryptoWalletCrypto',
  WITHDRAW_TO = 'withdrawTo',
  WITHDRAW_TO_CRYPTO_WALLET = 'withdrawToCryptoWallet',
  WITHDRAW_TO_FIAT_WALLET = 'withdrawToFiatWallet',
  WITHDRAW_TO_FIAT_WALLET_REVIEW = 'withdrawToFiatWalletReview',
  WITHDRAW_TO_FIAT_WALLET_SUCCESS = 'withdrawToFiatWalletSuccess',
  WITHDRAW_TO_FIAT_WALLET_ADD_BANK_ACCOUNT = 'withdrawToFiatWalletAddBankAccount',
}

type VoidFn = () => void;

interface WalletDrawerContextType {
  mounted: boolean;
  setMounted: (mounted: boolean) => void;
  drawerOpened: boolean;
  showDrawer: () => void;
  hideDrawer: () => void;
  toggleDrawer: () => void;
  walletOpened: boolean;
  showWallet: () => void;
  hideWallet: () => void;
  currentTab: WalletTab;
  setCurrentTab: (currentTab: WalletTab) => void;
  navFromMenu: boolean;
  setNavFromMenu: (bool: boolean) => void;
  walletIsLocked: boolean;
  setWalletIsLocked: (bool: boolean) => void;
  onBackButton: () => void;
  setBeforeBackButton: (fn: VoidFn) => void;
  closeWalletAndDrawer: () => void;
  recaptchaRef: RefObject<GoogleReCAPTCHA | null>;
}

export const WalletDrawerContext =
  createContext<WalletDrawerContextType | null>(null);

export const useWalletDrawerContext = () => useContext(WalletDrawerContext)!;
